import {
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
import React from "react";
import AddCategory from "../../Modals/addtopping";

const ManageDrivers = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const users = [
        {
            id: 1,
            name: "Madelyn Dias",
            email: "madelyndias@gmail.com",
            phone: "+91 9876543210",
            address: "Geofence1",
            totalOrder: 12,
            loalityPoints: 120,

        },
        {
            id: 2,
            name: "John Smith",
            email: "john@example.com",
            phone: "+91 9000011111",
            address: "Geofence2",
            totalOrder: 8,
            loalityPoints: 20,

        },
    ];
    return (
        <>
            <div className="main_title">
                <h1>Manage Drivers</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Drivers
                </p>
            </div>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search "
                        />
                    </div>
                    <div className="right_s">
                        <Button className="btn btn_primary" onClick={() => navigate("add")}>
                            <AddIcon /> Add Driver
                        </Button>
                    </div>
                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Details </TableCell>

                                <TableCell>Geofence</TableCell>
                                <TableCell>Total Orders</TableCell>

                                <TableCell>Enable / Disable</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {users.map((user) => (
                                <TableRow hover key={user.id}>
                                    <TableCell
                                        className="click_action"

                                    >
                                        <a

                                            onClick={(e) => {
                                                e.preventDefault();
                                                navigate("/manage-users/detail");
                                            }}
                                            className="user_block click_action"
                                        >
                                            <figure>
                                                <img src="/static/images/user_placeholder.png" alt="User" />
                                            </figure>
                                            <p><b>{user.name}</b>  <span>{user.phone}</span>  <span>{user.email}</span> </p>
                                        </a>
                                    </TableCell>



                                    <TableCell>{user.address}</TableCell>

                                    <TableCell>{user.totalOrder}</TableCell>
                                   

                                    <TableCell>
                                        <SwitchToggle />
                                    </TableCell>

                                    <TableCell>
                                        <div className="table_actions v2">
                                            <IconButton
                                                onClick={() =>
                                                    navigate("view", { state: { user } })
                                                }
                                            >
                                                <img src="/static/images/eye_icon.svg" alt="View" />
                                            </IconButton>
                                            <IconButton
                                                onClick={() =>
                                                    navigate("add", { state: { user } })
                                                }
                                            >
                                                <img src="/static/images/edit2_icon.svg" alt="View" />
                                            </IconButton>

                                            <IconButton >
                                                <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            <AddCategory open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
        </>
    );
};

export default ManageDrivers;
